import React from 'react';
import classnames from 'classnames';
import { Badge, BadgeProps } from 'reactstrap';
import './StatusBadge.scss';

/** Handles the logic of mapping a status (eg. `live`) to colors. */

const StatusColors = {
  published: 'primary',
  draft: 'draft',
  archived: 'archived',
  scheduled: 'info',
  past: 'incomplete',
  incomplete: 'incomplete',
  complete: 'complete',
  processing: 'info',
  available: 'info',
  accessRequested: 'incomplete',
  denied: 'danger',
  expired: 'expired',
};

export type StatusBadgeName =
  | 'published'
  | 'draft'
  | 'archived'
  | 'incomplete'
  | 'complete'
  | 'processing'
  | 'scheduled'
  | 'past'
  | 'available'
  | 'accessRequested'
  | 'denied'
  | 'expired';

interface Props extends BadgeProps {
  status: StatusBadgeName;
}

const getStatusName = (status: string) => {
  switch (status) {
    case 'accessRequested':
      return 'Access Requested';
    default:
      return status;
  }
};

const StatusBadge: React.FC<Props> = ({ status, ...badgeProps }) => (
  <Badge
    color={StatusColors[status]}
    className={classnames('status-badge', status)}
    {...badgeProps}
  >
    {getStatusName(status)}
  </Badge>
);

export default StatusBadge;
